import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import { EllipsisVertical, Flag } from "lucide-react";
import TipPostIcon from "../../../assets/TipPostIcon";
import { useCreatorPostStyles } from "../../Main/Sidebar/MyFeed-explore/style";
import ReportPostDialog from "../ReportPostDialog";

interface PostMenuButtonProps {
    post: any;
    onTip?: (post: any) => void;
}

export default function EllipsisMenuButton({
    post,
    onTip
}: PostMenuButtonProps) {
    const classes = useCreatorPostStyles();
    const [menuPos, setMenuPos] = useState<{ top: number; left: number } | null>(
        null
    );

    const [reportDialogOpen, setReportDialogOpen] = useState(false);
    const [reportPostId, setReportPostId] = useState<string | null>(null);

    const openMenu = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();

        const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();

        setMenuPos({
            top: rect.bottom,
            left: rect.right,
        });
    };

    const closeMenu = () => {
        setMenuPos(null);
    };

    const handleReport = (post: any) => {
        if (!post) return
        setReportPostId(post._id);
        setReportDialogOpen(true);
    }


    return (
        <>
            <IconButton onClick={openMenu}>
                <EllipsisVertical
                    color="#fff"
                    fill="#fff"
                    size={34}
                    style={{ strokeWidth: 1 }}
                />
            </IconButton>

            <Menu
                open={Boolean(menuPos)}
                onClose={() => closeMenu()}
                anchorReference="anchorPosition"
                anchorPosition={menuPos || { top: 0, left: 0 }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{ style: { position: "fixed" } }}
                disablePortal={false}
                className={classes.menu}
            >
                {!!onTip &&
                    <MenuItem className={classes.menuItemTip} onClick={() => {
                        closeMenu();
                        onTip(post);
                    }}>
                        <TipPostIcon />
                        Tip Creator
                    </MenuItem>}
                <MenuItem
                    disabled
                    className={classes.menuDivider}
                    style={{
                        borderTop: "1px solid #FFFFFF08",
                        margin: "12px 0",
                        padding: 0,
                        height: "1px",
                        minHeight: "1px",
                    }}
                />
                <MenuItem
                    className={classes.menuItemReport}
                    onClick={() => {
                        closeMenu();
                        handleReport(post);
                    }}
                >
                    <Flag size={24} />
                    Report Post
                </MenuItem>
            </Menu>

            <ReportPostDialog
                open={reportDialogOpen && !!reportPostId}
                onClose={() => {
                    setReportDialogOpen(false);
                    setReportPostId(null);
                }}
                targetId={reportPostId || ""}
            />
        </>
    );
}